module.exports = __webpack_public_path__ + "img/omimg1.4f50f59c.png";